import api from './api';

const ruleQ = (ruleId) => (ruleId ? `?ruleId=${ruleId}` : '');

const profileAssignmentService = {
    list:    (ppId, ruleId)               => api.get(`/paymentporter/${ppId}/profile-assignments${ruleQ(ruleId)}`),
    getById: (ppId, assignmentId)         => api.get(`/paymentporter/${ppId}/profile-assignments/${assignmentId}`),
    create:  (ppId, data, ruleId)         => api.post(`/paymentporter/${ppId}/profile-assignments${ruleQ(ruleId)}`, data),
    update:  (ppId, assignmentId, data)   => api.put(`/paymentporter/${ppId}/profile-assignments/${assignmentId}`, data),
    remove:  (ppId, assignmentId)         => api.delete(`/paymentporter/${ppId}/profile-assignments/${assignmentId}`),
};

export default profileAssignmentService;
